import ePlayerUIControllerTypes from '../eControllerTypes';

export default {
  EIT_DISPLAY_RTP: `${ePlayerUIControllerTypes.ECT_INFO_PANEL}__display_rtp`,
  EIT_NET_POSITION: `${ePlayerUIControllerTypes.ECT_INFO_PANEL}__net_position`,
  EIT_GAME_STATE: `${ePlayerUIControllerTypes.ECT_INFO_PANEL}__game_state`,
  EIT_STOPWATCH: `${ePlayerUIControllerTypes.ECT_INFO_PANEL}__stopwatch`,
}
